import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-customlib-updated',
  template: `
    <p>
      customlib-updated works!
    </p>
  `,
  styles: []
})
export class CustomlibUpdatedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
